export const WORDS = ['அனிச்சம்','இறைமாட்சி',
  'ஒற்றாடல்',
  'சொல்வன்மை',
  'ஒட்டகம்',
  'கருநாகம்',
  'சுரைக்காய்',
  'மிதிவண்டி',
  'மகிழ்ச்சி',
  'வாடாமல்லி', 
  'கீழாநெல்லி',
  'வெட்டிவேர்',
  'குப்பைமேனி',
  'சந்தனம்',
  'நங்கூரம்',
  'ஐந்திரம்',
  'நுண்ணுயிரி',
  'தாழ்ப்பாள்',
  'கிளிஞ்சல்',
  'நூற்றாண்டு',
  'மரபியல்',
  'மாம்பழம்',
  'மீன்கொத்தி',
  'வாய்க்கால்',
  'பாலைவனம்',
  'தொழிலாளர்',
  'வாழைமரம்',
  'இமயமலை',
  'திறவுகோல்',
  'எண்ணிக்கை',
  'விளையாட்டு',
  'பொறியியல்',
  'அட்டவணை',
  'கடுஞ்சொல்',
  'உரையாடல்',
  'முதியவர்',
  'அடக்கம்',
  'பூங்கொத்து',
  'எழுத்தாணி',
  'புற்றுநோய்',
  'நண்பகல்',
  'அரண்மனை',
  'குமுகாயம்',
  'ஊற்றுநீர்',
  'சிறுதொழில்', 
  'ஐம்புலம்',
  'கடற்கரை',
  'பேரங்காடி',
  'மின்கலம்', 
  'நுண்கருவி',
  'பிற்பகல்',
  'அமிழ்தம்',
  'ஆய்வியல்',
  'இளவேனில்',
  'உயிரினம்',
  'ஊதுகுழல்',
  'எண்ணியல்',
  'ஏலக்காய்',
  'ஐயப்பாடு',
  'ஒப்புரவு',
  'ஓய்விடம்',
  'கதிரவன்',
  'காப்பகம்',
  'கிரந்தம்',
  'கீழ்வானம்',
  'குடியரசு',
  'கூலிப்படை',
  'கெட்டவன்',
  'கேழ்வரகு',
  'கைத்தளம்',
  'கொள்கலன்',
  "சங்கதம்",
  "சான்றிதழ்",
  "சிலம்பம்",
  "சீரமைப்பு",
  "சுரங்கம்",
  "சூதாட்டம்",
  "செம்புலம்",
  "சேவையகம்",
  "சொல்வன்மை",
  "சோழபுரம்",
  "தகப்பன்",
  "தானியங்கி",
  "திருமணம்",
  "தீக்குச்சி",
  "துறைமுகம்",
  "தூதரகம்",
  "தென்மேற்கு",
  "தேன்சிட்டு",
  "தொடக்கம்",
  "தோகைமயில்",
  "பண்பாளர்",
  "பாறைக்கல்",
  "பின்னிரவு",
  "புதுமணம்",
  "பூகம்பம்",
  "பெருமிதம்",
  "பேரங்காடி",
  "பொல்லாங்கு",
  "போராட்டம்",
  "அறிவியல்",
  "ஆத்திசூடி",
  "இறையாண்மை",
  "கதம்பம்",
  "சக்கரம்",
  "தலைவாசல்",
  "பழங்குடி",
  "நறுமணம்",
  "மந்திரம்",
  "வயல்வெளி",
  "ஆசிரியர்",
  "கானல்நீர்",
  "சான்றாண்மை",
  "தாழ்வாரம்",
  "பாறாங்கல்",
  "ஆய்வுநூல்",
  "நாட்காட்டி",
  "மாறுவேடம்",
  "ஆள்காட்டி",
  "வான்புகழ்",
  "இளம்பிறை",
  "கிறுக்கல்",
  "சிக்கனம்",
  "திருத்தம்",
  "பிற்பகுதி",
  "இப்பொழுது",
  "நிகழ்ச்சி",
  "மின்னியல்",
  "இகழ்ச்சி",
  "விளையாட்டு",
  "ஈரமணல்",
  "கீழாநெல்லி",
  "சீரமைப்பு",
  "ஈரக்காடு",
  "தீப்பெட்டி",
  "ஈட்டிமுனை",
  "நீரோட்டம்",
  "மீன்கொத்தி",
  "ஈரநிலம்",
  "வீராங்கனை",
  "உளவியல்",
  "குடும்பம்",
  "சுருக்கம்",
  "துணிவுடைமை",
  "புதுமுகம்",
  "உயர்வகை",
  "நுண்ணறிவு",
  "உயர்திணை",
  "முதலுதவி",
  "உறவினர்",
  "ஊன்றுகோல்",
  "கூடாநட்பு",
  "சூத்திரம்",
  "தூக்கணம்",
  "பூங்கழல்",
  "ஊற்றுநீர்",
  "நூறாயிரம்",
  "ஊர்வலம்",
  "மூலமுதல்",
  "ஊமத்தம்",
  "எதிர்மறை",
  "கெண்டைமீன்",
  "செங்கதிர்",
  "தென்புலம்",
  "பெரும்பணி",
  "எண்வரிசை",
  "நெற்பயிர்",
  "மெய்யியல்",
  "எண்குணம்",
  "வெளிச்சம்",
  "ஏமாற்றம்",
  "கேள்விமுறை",
  "சேமவைப்பு",
  "தேரோட்டம்",
  "பேச்சாளர்",
  "ஏற்றுமதி",
  "நேர்காணல்",
  "மேம்பாலம்",
  "ஏற்புறுதி",
  "வேட்பாளர்",
  "ஒடுக்கம்",
  "கொள்முதல்",
  "சொல்லாடல்",
  "ஒழுக்கம்",
  "தொடுவானம்",
  "பொருத்தம்",
  "ஒப்புதல்",
  "நொய்ப்பம்",
  "மொழியியல்",
  "ஒருமுகம்",
  "ஓட்டுநர்",
  "கோத்தும்பி",
  "சோளக்காடு",
  "ஓரமைப்பு",
  "தோட்டவேலை",
  "போர்வீரர்",
  "ஓராயிரம்",
  "நோய்க்குறி",
  "ஓருள்ளம்",
  "மோர்ச்சாறு",
  "அருளுடைமை",
  "ஆழ்மனம்",
  "இடுக்கண்",
  "ஈராயிரம்",
  "உட்புறம்",
  "ஊர்வம்பு",
  "எதிர்முனை",
  "ஏழாயிரம்",
  "ஐயாயிரம்",
  "ஒப்பியல்",
  "ஓங்காரம்",
  "கட்டிடம்",
  "காகிதப்பூ",
  "கிளர்ச்சி",
  "கீழ்வரிசை",
  "கும்மாளம்",
  "கூரைதாங்கி",
  "கெட்டவள்",
  "கையொப்பம்",
  "கொழுமுதல்",
  "கோலாகலம்",
  "சமையலறை",
  "சாட்டையடி",
  "சிற்றிதழ்",
  "சீர்குலைவு",
  "சுற்றளவு",
  "சூட்டுவலி",
  "செயற்குழு",
  "சேகரிப்பு",
  "சொற்றொடர்",
  "சோளச்சோறு",
  "தடகளம்",
  "தாமரைப்பூ",
  "திருப்பம்",
  "தீக்கதிர்",
  "துடப்பம்",
  "தூண்டுகோல்",
  "தென்படும்",
  "தேவாலயம்",
  "தையற்கலை",
  "தொடர்கதை",
  "பச்சைமண்",
  "பாடத்துறை",
  "பூங்குழலி",
  "ஆதித்தன்",
  "கரிகாலன்",
  "பிதற்றல்",
  "புறநானூறு",
  "பூப்பந்து",
  "பெட்டகம்",
  "பேரகராதி",
  "பொதுவுடைமை",
  "நகைச்சுவை",
  "நாகரிகம்",
  "நிதித்துறை",
  "நீராட்டம்",
  "நுணுக்கம்",
  "நூற்கண்டு",
  "நெருக்கம்",
  "நேர்கோணம்", 
  "மணப்பெண்",
  "மாமன்னன்",
  "மிரட்டல்",
  "மீன்வளம்",
  "முக்கோணம்",
  "மூலக்கதை",
  "மெத்தனம்",
  "மேலோட்டம்",
  "மையெழுத்து",
  "மொழிமூலம்",
  "அடுக்களை",
  "ஆய்வுமுறை",
  "இசைக்கலை",
  "ஈடுபடும்",
  "உடல்மொழி",
  "ஊடுருவல்",
  "எங்ஙனம்",
  "ஏரிக்கரை",
  "ஐந்நிலம்",
  "ஒன்றியம்",
  "கதிர்முனை",
  "சமகாலம்",
  "தடுப்பணை",
  "பட்டணம்",
  "நடுக்கல்",
  "மணிக்கூடு",
  "காலவரிசை",
  "சாலையோரம்",
  "பாயும்புலி",
  "நாள்காட்டி",
  "கிறுக்கன்",
  "சிறந்தவை",
  "திரவியம்",
  "பிறங்கடை",
  "நிகழ்நிலை",
  "மின்னிதழ்",
  "குடியாட்சி",
  "சுத்தியல்",
  "துடைப்பம்",
  "புகைவண்டி",
  "அச்சகம்",
  "ஆய்வகம்",
  "இடர்பாடு",
  "ஈழப்போர்",
  "உணர்ச்சி",
  "ஊதுபத்தி",
  "அமைச்சர்",
  "அதிர்வலை",
  "அப்பொழுது",
  "அன்புடைமை",
  "அறிவுடைமை",
]